<template>
  <div class="wrapper">
    <side-bar>
      <sidebar-link v-for="item in menuItems" :key="item.to" v-if="itemVisible(item)" :to="item.to">
        <i :class="item.iconCls"></i>
        <p>{{ item.text }}</p>
      </sidebar-link>
      <mobile-menu slot="content"></mobile-menu>
    </side-bar>
    <div class="main-panel" id="main-panel">
      <div style="position:relative; height:100%;">
        <div class="mask-dashboard-content" v-if="this.$sidebar.showSidebar" @click="toggleSidebar">
        </div>
        <top-navbar></top-navbar>
        <dashboard-content>
        </dashboard-content>
        <content-footer></content-footer>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.mask-dashboard-content{
  position: absolute;
  height:100%;
  width:100%;
  background:#FFF;
  z-index:1;
  opacity: 0.5;
  filter: alpha(opacity=50);
  @media (min-width: 992px){
    display:none
  }
}
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    data: function () {
      return {
        menuItems: [
          {
            to: '/dashboard/home',
            text: 'Home',
            iconCls: 'fa fa-home',
            requiresAuth: false
          }, {
            to: '/dashboard/ore-lavoro',
            text: 'Ore di lavoro',
            iconCls: 'fa fa-clock-o',
            requiresAuth: true
          }, {
            to: '/dashboard/riepilogo-compensi',
            text: 'Riepilogo compensi',
            iconCls: 'fa fa-calendar-o',
            requiresAuth: true
          }, {
            to: '/dashboard/trattamenti',
            text: 'Trattamenti',
            iconCls: 'fa fa-paste',
            requiresAuth: true
          }, {
            to: '/dashboard/riepilogo-trattamenti',
            text: 'Riepilogo trattamenti',
            iconCls: 'fa fa-calendar-o',
            requiresAuth: true
          }, {
            to: '/dashboard/dipendente-list',
            text: 'Dipendenti',
            iconCls: 'fa fa-users',
            requiresAuth: true
          }, {
            to: '/dashboard/lavorazione-list',
            text: 'Lavorazioni',
            iconCls: 'fa fa-tasks',
            requiresAuth: true
          }, {
            to: '/dashboard/farmaco-list',
            text: 'Farmaci',
            iconCls: 'fa fa-asterisk',
            requiresAuth: true
          }, {
            to: '/dashboard/ortaggio-list',
            text: 'Ortaggio',
            iconCls: 'fa fa-leaf',
            requiresAuth: true
          }, {
            to: '/dashboard/setting',
            text: 'Impostazioni',
            iconCls: 'fa fa-cogs',
            requiresAuth: true
          }
        ]
      }
    },
    computed: {
      isAuth () {
        return this.$root.isAuth
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      itemVisible: function (item) {
        if (item.requiresAuth || item.requiresAuthType) {
          if (!this.$root.isAuth) {
            return false
          }
          if (!this.checkAuthType(item.requiresAuthType)) {
            return false
          }
        }
        return true
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue